export default "//static.tradera.net/touchweb/static/output/images/qr-code-google-play.1cf32d93.svg";